export default __webpack_public_path__ + "static/media/syslog_monitor.adad3a17.md";